import axios from "@/utils/axios";


//  用户密码登录
export const login = (data) => {
  return axios.post({
    url: '/login',
    data
  })
}
export const loginByWx = (data) => {
  return axios.get({
    url: '/v1/loginByWx',
    params:data
  })
}
export const loginNew = (data) => {
  console.log(data)
  // return Promise.resolve([])
  return axios.post({
    url: '/v1/sso-user/login/loginByPwd',
    data
  })
}
export const loginPhone = (data) => {
  console.log(data)
  // return Promise.resolve([])
  return axios.post({
    url: '/v1/sms-login',
    data
  })
}

// 用户登出  注销登录
export const logout = (data) => {
  return axios.post({
    url: '/v1/sso-user/login/loginOut'
  })
}

export const getInfo = (data) => {
  return axios.post({
    url: '/index',
    data
  })
}
export const getInfoNew = () => {
  return axios.get({
    url: '/v1/sso-user/product/getProductList',
  })
}